import { ApiProblemError } from '@taler/api-client'

/** The id names nothing on the server: a missing record, not a failed read. */
export function isNotFound(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.status === 404
}
